import {ICompanyInfo} from '../message-models/company-info.interface';

export class CompanyInfo implements ICompanyInfo{
  id: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressTown: string;
  addressCounty: string;
  addressPostcode: string;
  inlineAddress: string;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  referenceNumber: number;
  anyOptInsNotAccepted: boolean;
  trialValidTo: Date;

  contractAgreedBy: string = "";
  contractAgreedOn: Date | null = null;
  contractAgreed: boolean = false;

  constructor(iCompany: ICompanyInfo) {
    this.id =  iCompany?.id || '00000000-0000-0000-0000-000000000000';
    this.companyName =  iCompany?.companyName || '';
    this.addressLine1 =  iCompany?.addressLine1 || '';
    this.addressLine2 =  iCompany?.addressLine2 || '';
    this.addressLine3 =  iCompany?.addressLine3 || '';
    this.addressTown =  iCompany?.addressTown || '';
    this.addressCounty =  iCompany?.addressCounty || '';
    this.addressPostcode =  iCompany?.addressPostcode || '';
    this.contactName =  iCompany?.contactName || '';
    this.contactPhone =  iCompany?.contactPhone || '';
    this.contactEmail =  iCompany?.contactEmail || '';
    this.referenceNumber = iCompany?.referenceNumber || null;
    this.anyOptInsNotAccepted = iCompany?.anyOptInsNotAccepted;

    this.contractAgreedBy = iCompany?.contractAgreedBy;
    this.contractAgreedOn = iCompany?.contractAgreedOn;
    this.contractAgreed = iCompany?.contractAgreed;
    this.inlineAddress = iCompany?.inlineAddress;
  }
}
